import React from "react";
import DeleteIcon from "@material-ui/icons/Clear";
import IconButton from "@material-ui/core/IconButton";

export type DeleteProp = {
  onDeleteClick: () => void;
};

export function ExpDelete(props: DeleteProp) {
  const { onDeleteClick } = props;

  return (
    <IconButton
      onClick={onDeleteClick}
      style={{ position: "absolute", top: 0, right: 0 }}
    >
      <DeleteIcon fontSize="small" />
    </IconButton>
  );
}
